import { parseJSON } from './Shared';
import { Floor } from '../components/common/UnitMap/UnitMapTypes';

const UNITMAP_EXT_API_URL = 'https://api.unitmap.com/v1';
interface LevelData {
    data: LevelTag[];
}
interface LevelTag {
    key: string;
    values: Floor[];
}
export interface Unit {
    id: string;
    name: string;
}
interface UnitData {
    data: Unit[];
    paging: {
        per_page: number;
        current_page: number;
        prev_url: string;
        next_url: string;
    };
}
const apiKey = process.env.REACT_APP_UNITMAP_API_KEY;
export const getFloors = (mapId: string): Promise<Floor[]> => {
    let requestUrl = `${UNITMAP_EXT_API_URL}/maps/${mapId}/levels/tags`;
    let req = new Request(requestUrl, {
        method: 'get',
        headers: { 'API-key': apiKey ? apiKey : '' }
    });
    return fetch(req.clone())
        .then(response => parseJSON<LevelData>(response))
        .then(d => {
            if (d && d.data) {
                let floor = d.data.find(f => f.key === 'floor');
                if (floor) {
                    return floor.values;
                }
                return Promise.reject('No floor data found');
            }
            return Promise.reject('No data found');
        });
};

export const getUnits = (mapId: string, pageNumber?: number): Promise<Unit[]> => {
    let requestUrl =
        `${UNITMAP_EXT_API_URL}/maps/${mapId}/units` +
        `?page=${pageNumber ? pageNumber.toString() : '1'}` +
        `&per-page=1000`;
    let req = new Request(requestUrl, {
        method: 'get',
        headers: {
            'API-key': apiKey || ''
        }
    });
    return fetch(req.clone())
        .then(response => parseJSON<UnitData>(response))
        .then(d => {
            if (d && d.data && d.paging) {
                let units = d.data;
                if (d.paging.next_url !== null) {
                    return getUnits(mapId, d.paging.current_page + 1).then(u => units.concat(u));
                } else {
                    return units;
                }
            }
            return Promise.reject('No data found');
        });
};

export const checkMapId = (mapId: string): Promise<boolean> => {
    let requestUrl = `${UNITMAP_EXT_API_URL}/maps/${mapId}`;
    let req = new Request(requestUrl, {
        method: 'get',
        headers: { 'API-key': apiKey ? apiKey : '' }
    });
    return fetch(req.clone())
        .then(response => {
            if (!response.ok) {
                throw new Error('Map not found');
            }
            return response.blob();
        })
        .then(_b => {
            return true;
        })
        .catch(e => {
            return false;
        });
};



// WEBPACK FOOTER //
// ./src/api/Engrain.ts